// src/components/qualtrics/qualtrics.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query QualtricsConfigQuery($context: ContextInput!) {\n    qualtricsConfig(context: $context) {\n      zoneId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/qualtrics/script-blob.ts
var initQualtrics = function(zoneId) {
    var g = function g(e, h, f, g2) {
        this.get = function(a) {
            for(var a = "".concat(a, "="), c = document.cookie.split(";"), b = 0, e2 = c.length; b < e2; b++){
                for(var d = c[b]; d.charAt(0) == " ";)d = d.substring(1, d.length);
                if (d.indexOf(a) == 0) return d.substring(a.length, d.length);
            }
            return null;
        };
        this.set = function(a, c) {
            var b = "";
            var b = /* @__PURE__ */ new Date();
            b.setTime(b.getTime() + 6048e5);
            b = "; expires=".concat(b.toGMTString());
            document.cookie = "".concat(a, "=").concat(c).concat(b, "; path=/; ");
        };
        this.check = function() {
            var a = this.get(f);
            if (a) a = a.split(":");
            else if (e != 100) h == "v" && (e = Math.random() >= e / 100 ? 0 : 100), a = [
                h,
                e,
                0
            ], this.set(f, a.join(":"));
            else return true;
            var c = a[1];
            if (c == 100) return true;
            switch(a[0]){
                case "v":
                    return false;
                case "r":
                    return c = a[2] % Math.floor(100 / c), a[2]++, this.set(f, a.join(":")), !c;
            }
            return true;
        };
        this.go = function() {
            if (this.check()) {
                var a = document.createElement("script");
                a.type = "text/javascript";
                a.src = g2;
                document.body && document.body.appendChild(a);
            }
        };
        this.start = function() {
            var t = this;
            document.readyState !== "complete" ? window.addEventListener ? window.addEventListener("load", function() {
                t.go();
            }, false) : window.attachEvent && window.attachEvent("onload", function() {
                t.go();
            }) : t.go();
        };
    };
    try {
        new g(100, "r", "QSI_S_".concat(zoneId), "https://".concat(zoneId.toLowerCase().replace(/_/g, ""), "-expediainc.siteintercept.qualtrics.com/SIE/?Q_ZID=").concat(zoneId)).start();
    } catch (i) {}
};
var script_blob_default = initQualtrics;
// src/components/qualtrics/qualtrics.tsx
var __Query = gql(_templateObject());
var Qualtrics = function(props) {
    var _data_qualtricsConfig;
    var context = useBexApi().context;
    var skipSsr = props.skipSsr;
    var variables = {
        context: context
    };
    var _useQuery = useQuery(__Query, {
        variables: variables,
        fetchPolicy: "network-only",
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var zoneId = data === null || data === void 0 ? void 0 : (_data_qualtricsConfig = data.qualtricsConfig) === null || _data_qualtricsConfig === void 0 ? void 0 : _data_qualtricsConfig.zoneId;
    React.useEffect(function() {
        return function() {
            var qsi = typeof window === "undefined" ? null : window === null || window === void 0 ? void 0 : window.QSI;
            var tcVars = typeof window === "undefined" ? null : window === null || window === void 0 ? void 0 : window.tc_vars;
            if (qsi === null || qsi === void 0 ? void 0 : qsi.API) {
                qsi.API.unload();
                var oldPageName = tcVars.event_page_name;
                var counter = 1;
                var interval = setInterval(function() {
                    if (oldPageName !== tcVars.event_page_name) {
                        qsi.API.unload();
                        qsi.API.load();
                        qsi.API.run();
                        clearInterval(interval);
                    } else if (counter === 100) {
                        clearInterval(interval);
                        qsi.API.unload();
                        qsi.API.load();
                        qsi.API.run();
                    }
                    counter += 1;
                }, 100);
            }
        };
    }, []);
    React.useEffect(function() {
        script_blob_default(zoneId);
    }, [
        zoneId
    ]);
    if (loading || error || !zoneId) {
        return null;
    }
    return /* @__PURE__ */ React.createElement("div", {
        "data-stid": zoneId,
        id: zoneId
    });
};
Qualtrics.displayName = "Qualtrics";
export { Qualtrics };
//# sourceMappingURL=index.js.map